var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pixelarticons:money"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.25 13H8V41.5H17.5V51H55.5V22.5H46V13H41.25ZM41.25 17.75V22.5H17.5V36.75H12.75V17.75H41.25ZM22.25 27.25H50.75V46.25H22.25V27.25ZM41.25 32H31.75V41.5H41.25V32Z",
    fill: "#0A0A0A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon-4.b40a83376591c1347ac09c818bf88348.svg";
export { ForwardRef as ReactComponent };